import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { DirectivesModule } from '../../../projects/kiene-core/src/lib/directives/directives.module';
import { KieneClientAutocompleteModule } from '../components/client-autocomplete/client-autocomlete.module';
import { ComponentsModule } from '../components/components.module';
import { KieneAutocompleteModule } from '../components/kiene-autocomplete/kiene-autocomplete.module';
import { SelectorModule } from '../components/selector/selector.module';
import { AbgabebelegChargeDialogComponent } from './abgabebeleg-charge-dialog/abgabebeleg-charge-dialog.component';
import { AddBetriebsartDialogComponent } from './add-betriebsart-dialog/add-betriebsart-dialog.component';
import { AddClientArtikelDialogComponent } from './add-client-artikel-dialog/add-client-artikel-dialog.component';
import { AddFilesDialogComponent } from './add-files-dialog/add-files-dialog.component';
import { BenutzerrechteDialogComponent } from './benutzerrechte-dialog/benutzerrechte-dialog.component';
import { CalendarWeekPickerComponent } from './calendar-week-picker/calendar-week-picker.component';
import { CalendarWeekSelectorDialogComponent } from './calendar-week-picker/calendar-week-selector-dialog/calendar-week-selector-dialog.component';
import { ChangeAntibiogrammClientDialogComponent } from './change-antibiogramm-client-dialog/change-antibiogramm-client-dialog.component';
import { ChangeUserEmailAccountDialogComponent } from './change-user-email-account-dialog/change-user-email-account-dialog.component';
import { ConfirmDeleteDialogComponent } from './confirm-delete-dialog/confirm-delete-dialog.component';
import { ConfirmWithOptionDialogComponent } from './confirm-with-option-dialog/confirm-with-option-dialog.component';
import { DateRangeDialogComponent } from './date-range-dialog/date-range-dialog.component';
import { EditBetriebsartDialogComponent } from './edit-betriebsart-dialog/edit-betriebsart-dialog.component';
import { EditClientArtikelDialogComponent } from './edit-client-artikel-dialog/edit-client-artikel-dialog.component';
import { FileUploadDialogComponent } from './file-upload-dialog/file-upload-dialog.component';
import { HitSyncEinstellungenDialogComponent } from './hit-sync-einstellungen-dialog/hit-sync-einstellungen-dialog.component';
import { InvoiceGenerationDialogComponent } from './invoice-generation-dialog/invoice-generation-dialog.component';
import { JsonDialogComponent } from './json-dialog/json-dialog.component';
import { SaveForAllDialogComponent } from './save-for-all-dialog/save-for-all-dialog.component';
import { SelectMandantDialogComponent } from './select-mandant-dialog/select-mandant-dialog.component';
import { SelectorDialogComponent } from './selector-dialog/selector-dialog.component';
import { TextBausteinDialogComponent } from './text-baustein-dialog/text-baustein-dialog.component';
import { TexteingabeDialogComponent } from './texteingabe-dialog/texteingabe-dialog.component';

@NgModule({
    declarations: [
        AbgabebelegChargeDialogComponent,
        AddBetriebsartDialogComponent,
        AddClientArtikelDialogComponent,
        AddFilesDialogComponent,
        ChangeAntibiogrammClientDialogComponent,
        ChangeUserEmailAccountDialogComponent,
        ConfirmDeleteDialogComponent,
        EditBetriebsartDialogComponent,
        EditClientArtikelDialogComponent,
        InvoiceGenerationDialogComponent,
        TextBausteinDialogComponent,
        JsonDialogComponent,
        SaveForAllDialogComponent,
        BenutzerrechteDialogComponent,
        ConfirmWithOptionDialogComponent,
        FileUploadDialogComponent,
        SelectMandantDialogComponent,
        SelectorDialogComponent,
        CalendarWeekPickerComponent,
        CalendarWeekSelectorDialogComponent,
        DateRangeDialogComponent,
        TexteingabeDialogComponent,
        HitSyncEinstellungenDialogComponent,
    ],
    imports: [
        CommonModule,
        MatTabsModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatCardModule,
        MatMenuModule,
        MatChipsModule,
        MatToolbarModule,
        MatExpansionModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatPaginatorModule,
        MatRadioModule,
        MatDividerModule,
        MatBadgeModule,
        MatTreeModule,
        MatTableModule,
        MatListModule,
        MatAutocompleteModule,
        KieneAutocompleteModule,
        KieneClientAutocompleteModule,
        ComponentsModule,
        SelectorModule,
        MatGridListModule,
        DirectivesModule,
        MatButtonToggleModule,
    ],
    exports: [CalendarWeekPickerComponent],
})
export class DialogsModule {}
